var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11111 11.1667H12.4444V12.9444H7.11111V11.1667ZM5.33333 4.05556H3.55556V5.83333H5.33333V4.05556ZM7.11111 9.38889H12.4444V7.61111H7.11111V9.38889ZM7.11111 5.83333H12.4444V4.05556H7.11111V5.83333ZM5.33333 7.61111H3.55556V9.38889H5.33333V7.61111ZM16 2.27778V14.7222C16 15.7 15.2 16.5 14.2222 16.5H1.77778C0.8 16.5 0 15.7 0 14.7222V2.27778C0 1.3 0.8 0.5 1.77778 0.5H14.2222C15.2 0.5 16 1.3 16 2.27778ZM14.2222 2.27778H1.77778V14.7222H14.2222V2.27778ZM5.33333 11.1667H3.55556V12.9444H5.33333V11.1667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.248f3f22a957ee25bd7add4070ed20f1.svg";
export { ForwardRef as ReactComponent };